// Admin API client — /admin/stats/* (mirrors the API's stats aggregate).

import type {
  KeywordDatabaseBlock,
  StatsOverviewBlock,
  StatsOverviewBlockName,
  KeywordDatabaseFill,
  KeywordDatabaseFillDays,
} from '@a7y/types';
import { client, adminQueryUrl } from './transport';

export const statsApi = {
  // Stats (A7Y-4883) — every block is cached server-side; `force` bypasses the cache.
  stats: {
    keywordDatabase: {
      block: <T>(
        name: 'headline' | 'overview' | 'markets' | 'sources' | 'coverage',
        opts?: { force?: boolean }
      ) =>
        client.get<{ data: KeywordDatabaseBlock<T> }>(
          adminQueryUrl(`/stats/keyword-database/${name}`, { force: opts?.force })
        ),
      fill: (days: KeywordDatabaseFillDays, opts?: { force?: boolean }) =>
        client.get<{ data: KeywordDatabaseBlock<KeywordDatabaseFill> }>(
          adminQueryUrl('/stats/keyword-database/fill', { days, force: opts?.force })
        ),
    },
    // Overview (A7Y-5020) — three independently cached blocks; `force` re-runs the live counts and
    // re-reads (does not recompute) the nightly snapshot.
    overview: {
      block: <T>(name: StatsOverviewBlockName, opts?: { force?: boolean }) =>
        client.get<{ data: StatsOverviewBlock<T> }>(
          adminQueryUrl(`/stats/overview/${name}`, { force: opts?.force })
        ),
    },
  },
};
